<template>
  <div>
    <v-app-bar id="home-app-bar" app elevation="1" height="80">
      <router-link to="/">
        <base-img
          :src="require('@/assets/logo.svg')"
          class="mr-3 mb-1 hidden-xs-only"
          contain
          max-width="170"
          width="170"
          max-height="78"
        />
      </router-link>

      <template v-if="loggedIn">
        <div class="ml-5">
          <v-btn color="primary" text href="/project"> PROJECT </v-btn>
        </div>
      </template>
      <v-spacer />

      <!-- logged -->
      <template v-if="loggedIn">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" text v-bind="attrs" v-on="on">
              {{ user_info.real_name }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item key="menu1">
              <v-list-item-title
                ><router-link to="/mypage">
                  My profile
                </router-link></v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn color="primary" @click="logout">LogOut </v-btn>
      </template>
      <!-- not logged -->
      <template v-else>
        <div>
          <div>
            <router-link to="/mypage" style="text-decoration: underline">
              <v-btn color="primary" type="submit">Register/Login </v-btn>
            </router-link>
          </div>
          <div style="margin-top: 5px; font-size: 0.8rem">
            to upload your own ligands to fragmaps
          </div>
        </div>
      </template>
    </v-app-bar>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from "vuex";

export default {
  name: "HomeAppBar",

  data: () => ({
    drawer: null,
    items: ["project"],
  }),
  computed: {
    ...mapState(["user_info"]),
    ...mapGetters(["loggedIn"]),
  },
  methods: {
    ...mapMutations(["logout"]),
  },
};
</script>

<style lang="sass">
#home-app-bar
  .v-tabs-slider
    max-width: 24px
    margin: 0 auto

    .v-tab
      &::before
        display: none
</style>
